import { useTranslation } from "react-i18next";
import CustomCheckbox from "../../../../custom-components/form-inputs/CustomCheckbox";
import CheckMarkIconSVG from "../../svg/CheckMarkIconSVG";
import { FormikProps } from "formik";
import { FormWithPhones, PhoneInfoForm } from "../../../../domain/models/dto/PhoneDTO";
import CustomError from "../../../../custom-components/form-inputs/CustomError";
import { Fields } from "../../../../types/SchemaFactory";
import PhoneInput from "../form-inputs/PhoneInput";
import _ from "lodash";

interface DesktopPhoneInfoProps<T> {
    form: FormikProps<T>;
    fields: Fields<T>;
    value: PhoneInfoForm;
    index: number;
    viberCheckboxHandler: (index: number) => () => void;
    whatsappCheckboxHandler: (index: number) => () => void;
}

function DesktopPhoneInfo<T extends FormWithPhones>(props: DesktopPhoneInfoProps<T>) {
    const { t } = useTranslation();

    return (
        <div className="flex justify-between w-full">
            <div key={"phone-info-component-" + props.index}>
                <div className="flex items-center justify-between mt-4 dmax2:mt-3">
                    <div className="flex flex-col">
                        <div className="flex items-center">
                            <p className="H16B dmax2:H14B text-textWhite mt4:w-[75px] td4:w-[135px] dmin2:w-[200px] tmin3:mr-3">
                                {t(
                                    props.index < 1
                                        ? "phoneInfo.fields.phoneField"
                                        : "phoneInfo.fields.additionalPhoneField"
                                )}
                            </p>
                            <PhoneInput
                                form={props.form}
                                name={`phones.${props.index}.phone`}
                                meta={props.fields.phones.schema.phone}
                                className="w-[330px] di6:w-[300px] ti7:w-[250px] tmax4:w-[204px] h-[52px] dmax2:h-[45px]"
                            />
                        </div>
                        <CustomError
                            errorKey={_.get((props.form.errors.phones as string[])?.at(props.index), "phone")}
                            className="dmin2:pl-[212px] di6:pl-[148px] mt-2 dmax2:mt-1"
                        />
                    </div>
                </div>
            </div>
            <div className="flex items-start di6:mt-4 dmin2:mt-5">
                <div className="flex items-center mr-8 dmax2:mr-6">
                    <CustomCheckbox
                        labelKey=""
                        checked={props.value.viber}
                        onClick={props.viberCheckboxHandler(props.index)}
                        checkboxClassName="flex justify-center items-center w-6 h-6 border-2 border-textFaded rounded-sm cursor-pointer transition duration-200 mr-4 tmax4:mr-3"
                        checkboxCheckedClassName="!border-0 bg-textWarning"
                        wrapClassName="flex items-center tmax4:items-start"
                        additionalLayoutElement={<CheckMarkIconSVG />}
                    />
                    <img src="images/viber.png" alt="viber" className="w-9 tmax4:w-8 h-9 tmax4:h-8" />
                </div>
                <div className="flex items-center">
                    <CustomCheckbox
                        labelKey=""
                        checked={props.value.whatsapp}
                        onClick={props.whatsappCheckboxHandler(props.index)}
                        checkboxClassName="flex justify-center items-center w-6 h-6 border-2 border-textFaded rounded-sm cursor-pointer transition duration-200 mr-4 tmax4:mr-3"
                        checkboxCheckedClassName="!border-0 bg-textWarning"
                        wrapClassName="flex items-center tmax4:items-start"
                        additionalLayoutElement={<CheckMarkIconSVG />}
                    />
                    <img src="images/whatsapp.png" alt="whatsapp" className="w-9 tmax4:w-8 h-9 tmax4:h-8" />
                </div>
            </div>
        </div>
    );
}

export default DesktopPhoneInfo;
